import { GetApiData } from "utils/http-client";

export const Assignments = async (data) => {
    return await GetApiData(`/assignment`, 'POST', data, true);
};
export const deleteAssignments = async (id) => {
    return await GetApiData(`/assignment/${id}`, 'DELETE', null, true);
};
export const getAllAssignment = async (page="1", limit=10, type="", assign="", sort="", search="", source="", classId = null) => {
    const queryParams = [];

    if (page) queryParams.push(`page=${page}`);
    if (limit) queryParams.push(`limit=${limit}`);
    if (type) queryParams.push(`exerciseType=${type}`);
    if (assign) queryParams.push(`sourceType=${assign}`);
    if (sort) queryParams.push(`sort=${sort}`);
    if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
    if (source) queryParams.push(`source=${source}`);
    if (classId) queryParams.push(`classId=${classId}`);

    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

    return await GetApiData(`/assignment${queryString}`, 'GET', null, true);
};

export const getAllStudentAssignment = async (page="1", limit=10, status="", subject="", sort="", search="", source="", classId = null) => {
    const queryParams = [];

    if (page) queryParams.push(`page=${page}`);
    if (limit) queryParams.push(`limit=${limit}`);
    if (subject) queryParams.push(`subject=${subject}`);
    if (status) queryParams.push(`submissionStatus=${status}`);
    if (sort) queryParams.push(`sort=${sort}`);
    if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
    if (source) queryParams.push(`source=${source}`);
    if (classId) queryParams.push(`classId=${classId}`);

    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

    return await GetApiData(`/assignment${queryString}`, 'GET', null, true);
};
export const getAssignmentAttempts = async (id,page, limit=10) => {
    const queryParams = [];

    if (page) queryParams.push(`page=${page}`);
    if (limit) queryParams.push(`limit=${limit}`);

    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

    return await GetApiData(`/submission/vocabulary/${id}${queryString}`, 'GET', null, true);
};

// No status filter: the list shows every submission and labels each one, so a
// teacher can review already-marked work as well as what still needs marking.
export const getAllSubmissions = async (id) => {
    return await GetApiData(`/submission/${id}`, 'GET', null, true);
};

export const getSpecificSubmissions = async (id, type, currentPageTable, limitTable,subject, sort, search) => {
    return await GetApiData(`/assignment/collective/${id}?type=${type}&page=${currentPageTable}&limit=${limitTable}&subject=${subject}&sort=${sort}&search=${search}`, 'GET', null, true);
};

export const getLessonPlannerAssignments = async () => {
    return await GetApiData(`/assignment/lesson-planner`, 'GET', null, true);
};

export const getAssignmentDetails = async (id) => {
    return await GetApiData(`/assignment/${id}`, 'GET', null, true);
};

// Every student the assignment targets (individual roster or class/group
// membership) together with each student's current status.
export const getAssignmentStudents = async (id) => {
    return await GetApiData(`/assignment/${id}/students`, 'GET', null, true);
};

export const updateAssignment = async (id, data) => {
    return await GetApiData(`/assignment/${id}`, 'PUT', data, true);
};

